import { RefObject } from 'react';

export type MapContextUnsafe = {
  map: YMaps.Map | undefined;
  mapRef: RefObject<HTMLElement | null>;
  ymaps: YMaps.IYMaps | undefined;
};

export type MapContextSafe = {
  map: YMaps.Map;
  mapRef: RefObject<HTMLElement>;
  ymaps: YMaps.IYMaps;
};

export type MapContext = MapContextUnsafe | MapContextSafe;

export const ensureMapContextInitialized = (context: MapContext): context is MapContextSafe => {
  return !!(context.ymaps && context.map && context.mapRef.current);
};
